import InputTypesEnum from "../../../Enums/InputTypesEnum";
import SearchParamsBase from "../../../Elements/SearchParamsBase";

export default class ApolloShopCopierSearchParams extends SearchParamsBase
{
	initialize()
	{
		this.Id="";
		this.OriginalJobId="";
		this.NewJobId="";
		this.SurveyId="";
		this.FormName="";
		this.UserLocId="";
		this.Status="";

	}

	//-------------------------------------------
	//-------- Fields for Search Panel ----------
	//-------------------------------------------

	static fieldsInSearchBox=[
		{fieldName:"Id",label:"Id", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"OriginalJobId",label:"Original Job Id", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"NewJobId",label:"New Job Id", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"SurveyId",label:"Survey Id", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"FormName",label:"Form Name", className:"col-4", type: InputTypesEnum.Text},
		{fieldName:"UserLocId",label:"User Loc Id", className:"col-4", type: InputTypesEnum.Text},
		{fieldName:"Status",label:"Status", className:"col-4", type: InputTypesEnum.Select, options: ApolloShopCopierSearchParams.getSelectOptions(),},
	];

	static iconName="fa-solid fa-search";
	static saveType="ApolloShopCopierSearchParams";

	//---------------------------

	static getSelectOptions() 
	{
		return [
			{ label: "", value: "", disabled: false },
			{ label: "Downloaded from Apollo", value: "Downloaded from Apollo", disabled: false },
			{ label: "Duplicated", value: "Duplicated", disabled: false },
			{ label: "Error", value: "Error", disabled: false },
			{ label: "Processing", value: "Processing", disabled: false },
		];
	}
	
}